import { run } from 'common/supabase/utils'
import { db } from 'web/lib/supabase/db'
import { type DisplayUser } from 'common/api/user-types'

export async function getReferrals(userId: string) {
  const { data } = await run(
    (
      db
        .from('users')
        .select(
          `id, name, username, is_bot, data->avatarUrl, data->isBannedFromPosting`
        ) as any
    ).contains('data', {
      referredByUserId: userId,
    })
  )

  return (data ?? []).map((user: any) => ({
    ...user,
    isBot: user.is_bot ?? undefined,
  })) as DisplayUser[]
}
